import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './styles/App.css';
import { ThemeProvider, CssBaseline, Box, createTheme } from '@mui/material';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Search from './pages/Search';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import SavedMaterials from './pages/SavedMaterials';
import { AuthProvider } from './contexts/AuthContext';
import InspirationBoard from './components/InspirationBoard';
import ProjectBoard from './components/ProjectBoard';
import Footer from './components/Footer';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  const AppContent = () => {
    const location = useLocation();
    const isHomePage = location.pathname === '/';

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', overflowX: 'hidden' }}>
        <Navbar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: isHomePage ? 0 : 3,
            mt: isHomePage ? 0 : 8,
            backgroundColor: isHomePage ? 'transparent' : 'background.default',
            position: isHomePage ? 'relative' : 'static',
            overflowX: 'hidden',
            minHeight: isHomePage ? 'calc(100vh - 64px)' : 'auto',
          }}
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/search" element={<Search />} />
            <Route path="/saved" element={<SavedMaterials />} />
            <Route path="/boards" element={<InspirationBoard />} />
            <Route path="/project-board" element={<ProjectBoard />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
          </Routes>
        </Box>
        <Footer />
      </Box>
    );
  };

  return (
    <AuthProvider>
      <Router>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AppContent />
        </ThemeProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;
